import { css } from '@emotion/react';
import t from 'react-translate';
import { useSelector } from 'react-redux';

import { getFlatCourseAliases } from 'redux/selectors/course';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import NvGeneratingLoader from 'shared/components/loaders/nv-generating-loader';

const styles = css`
  .lh-25 {
    line-height: 25px;
  }
`;

const AiGenerationPreview = () => {
  const params = useLecturePageParams();
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));

  return (
    <div className='d-flex flex-column align-items-center justify-content-center py-5' css={styles}>
      <NvGeneratingLoader className='mb-0' />
      <p className='text-regular text-gray-2 lh-25 mb-0 mt-2'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.READING_CONTENT()}</p>
      <p className='text-regular text-gray-2 lh-25 mb-0'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.WRITING_CONTEXT()}</p>
      <p className='text-regular text-gray-2 lh-25 mb-0'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.CREATING_AI_OBJECTIONS()}</p>
      <p className='text-regular text-gray-2 lh-25 mb-0'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.CREATING_LEARNER_GOALS(courseAliases)}</p>
    </div>
  );
};

export default AiGenerationPreview;
